module.exports = function getResource(label, vars = []) {
    let resources = {
        done: 'Done',
        all: 'All',
        clear: 'Clear',
        shade: 'Shade'
    };
    return resources[label];
};
